import React from 'react'

import FontFile from '../shared/font-file'

const Word = (props) => {
  return (
    <FontFile
      font={'painted'}
      topOffset="-0.28em"
      multiplier={1.15}
      emojiOffset="0.25em"
      {...props}
    />
  )
}

export default Word
